// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"bbu_a bhu_g"};